import React from 'react';
import { Label, TextField } from '@fluentui/react';

import styles from '../../styles/component.module.scss';

export interface ITextboxField {
	label: string;
	description: string;
	error?: string;
	onChange: (value: string) => void;
}

export const TextboxField = (props: ITextboxField) => {
	const changeValue = (
		event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
		newValue?: string | undefined
	) => {
		props.onChange(newValue ? newValue : '');
	};

	return (
		<div>
			<Label required={true}>{props.label}</Label>
			<div>
				<TextField multiline rows={6} errorMessage={props.error} onChange={changeValue} />
				<p className={styles.descriptionText}>{props.description}</p>
			</div>
		</div>
	);
};
